import { http } from "@/lib/http-client";

export interface HealthStatus {
  status: string;
  time: string;
}

export const healthService = {
  async getHealth(): Promise<HealthStatus> {
    const response = await http.get<HealthStatus>("/api/health");
    if (
      response !== null &&
      typeof response === "object" &&
      "status" in response
    ) {
      return response as HealthStatus;
    }
    return { status: "unknown", time: new Date().toISOString() };
  },
};
